import { useForm } from 'react-hook-form';
import { EmailVerificationModel, UserProviderValue } from '../models';
import { EmailVerificationSchema } from '../schemas';
import { zodResolver } from '@hookform/resolvers/zod';
import { useContext, useEffect, useState } from 'react';
import { logout, resetPasswordRequestLink } from '../services';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import { UserContext } from '../contexts/user.context';

export function useForgotPassword() {
   const navigate = useNavigate();
   const location = useLocation();

   const { setUser, setIsAuthenticated, setIsLoginModalOpen } = useContext<UserProviderValue>(UserContext);

   const userForgotPasswordForm = useForm<EmailVerificationModel>({
      resolver: zodResolver(EmailVerificationSchema),
      mode: 'onChange',
   });

   const [isLoading, setIsLoading] = useState(false);

   useEffect(() => {
      if (location.pathname === '/reset-password' && setIsAuthenticated) {
         setUser(undefined);
         setIsAuthenticated(false);
         logout();
      }
   }, [location.pathname]);

   const submitForgotPassword = async (data: EmailVerificationModel) => {
      setIsLoading(true);

      const resetResponse = await resetPasswordRequestLink(data.email);

      if (resetResponse.error) {
         toast.error(resetResponse.error?.message || 'No account found with that email');
         setIsLoading(false);
         return;
      }

      toast.success('Password reset link sent successfully. Please check your email');
      navigate('/login');

      setIsLoading(false);
   };

   return {
      submitForgotPassword,
      isLoading,
      userForgotPasswordForm,
      setIsLoginModalOpen,
   };
}
